import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { HistoryOutlined } from '@mui/icons-material'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { useIntl } from 'react-intl'

interface MenuBanHistoryProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuBanHistory = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuBanHistoryProps) => {
  const { formatMessage } = useIntl()
  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/live-chat/ban-history?page=1&page_size=10"
        selected={pathname.startsWith('/live-chat/ban-history')}
      >
        <ListItemIcon>
          <HistoryOutlined />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'liveChat.sidebar.banHistory',
          })}
        />
      </MenuItem>
    </div>
  )
}
